import { render, staticRenderFns } from "./IndividualNoTicketMetadata.vue?vue&type=template&id=2c1a5c4c&"
import script from "./IndividualNoTicketMetadata.vue?vue&type=script&lang=ts&"
export * from "./IndividualNoTicketMetadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports